module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-08.9e1453db.png";